import { GetProp, Layout, Menu, MenuProps } from "antd";
import { useMemo } from "react";
import {
  Activity,
  Clipboard,
  FileText,
  Grid,
  Home,
  Scissors,
  User,
  Users,
} from "react-feather";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
type MenuItem = GetProp<MenuProps, "items">[number];

const Sider = () => {
  const location = useLocation();
  const { user, hasPermission } = useAuth();
  const { Sider } = Layout;
  //   const [active, setActive] = useState('')

  // Split the pathname and get the first segment
  const splitPath = location.pathname.split("/").slice(1);
  const currentMenu = splitPath.join("/");
  console.log(splitPath);
  const navigate = useNavigate();

  const getMenuItems = () => {
    const items: MenuItem[] = [
      { key: "dashboard", label: "Dashboard", icon: <Grid size={16} /> },
    ];
    if (!user) return [];
    if (hasPermission("list:users")) {
      items.push({ key: "users", label: "Users", icon: <Users size={16} /> });
    }
    if (hasPermission("list:staffs")) {
      items.push({ key: "staffs", label: "Staffs", icon: <Users size={16} /> });
    }
    if (hasPermission("list:stores")) {
      items.push({ key: "stores", label: "Stores", icon: <Home size={16} /> });
    }
    if (hasPermission("list:clients")) {
      items.push({
        key: "clients",
        label: "Clients",
        icon: <User size={16} />,
      });
    }
    if (hasPermission("list:services")) {
      items.push({
        key: "services",
        label: "Services",
        icon: <Scissors size={16} />,
      });
    }
    if (hasPermission("list:orders")) {
      items.push({
        key: "orders",
        label: "Orders",
        icon: <Clipboard size={16} />,
      });
    }
    if (hasPermission("list:activity")) {
      items.push({
        key: "activity",
        label: "Activity",
        icon: <Activity size={16} />,
      });
    }
    if (hasPermission("list:reports")) {
      items.push({
        key: "reports",
        label: "Reports",
        icon: <FileText size={16} />,
        children: [
          { key: "reports/eod", label: "End of day" },
          { key: "reports/comprehensive", label: "Comprehensive" },
        ],
      });
    }
    return items;
  };
  const items = useMemo(getMenuItems, []);

  return (
    <Sider id="sider">
      <div
        style={{
          height: 32,
          margin: 16,
        }}
        className="flex justify-center items-center "
      >
        <h1 className="text-white text-xl font-extrabold">ParlorPilot</h1>
      </div>
      <Menu
        theme="dark"
        mode="inline"
        onSelect={(event) => navigate(`/${event.key}`)}
        className="px-2"
        selectedKeys={[currentMenu]}
        items={items}
      />
    </Sider>
  );
};

export default Sider;
